const getOptimizedImage = (imagePath, parameters = '&w=300') => {
  return imagePath
    ? `${process.env.REACT_APP_IMAGE_CDN_URL}/${imagePath}?auto=compress${parameters}`
    : null;
};

export default getOptimizedImage;
